import React, {useEffect, useState} from "react";
import {Alert, Backdrop, CircularProgress, Container, Pagination, styled} from "@mui/material";
import ContributionSearchPanel from "./ContributionSearchPanel";
import {ApiUrl} from "../utils/portal-urls";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import ShowSnackbar from "../utils/ShowSnackbar";
import ContributionsAsList from "./ContributionsAsList";
import {useSelector} from "react-redux";
import {CustomBackdrop, StyledContainer} from "../utils/customStyles";
import ContributionsAsWidgetList from "./ContributionsAsWidgetList";

export default function RecentContributionsWidget (props) {
    const [tableListLoading, setTableListLoading] = useState(false);
    const [refresh, setRefresh] = useState(new Date().getTime());
    const [page, setPage] = useState(0);
    const query = "";
    const [pageResult, setPageResult] = useState(null);
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});
    const [exportQuery, setExportQuery] = useState("");


    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchPage(query, page);
        }
    }, [query, page, refresh])


    const fetchPage = async (query, page) => {
        setTableListLoading(true);
        const url = ApiUrl.Contributions.query.getPath(query, page);
        console.log("GET contribution from: " + url);
        try {
            const res = await fetch(url)
            const data = await handleHttpResponse(res);
            setCurrentViewingQuery(query);
            setExportQuery(query);
            setPageResult(data);
        } catch (err) {
            console.error("failed to get contribution page: " + err)
            setSnackbarMsg({open: true, msg: 'Failed to Get Contribution Page', msgLv: 'error'});
        } finally {
            setTableListLoading(false);
        }
    }

    return (
        <StyledContainer maxWidth='xl'>
            {tableListLoading && <Alert severity='info' icon={<CircularProgress />} style={{lineHeight: '37px'}} > Loading recent contributions... </Alert> }
            {!tableListLoading && <div className="contribution-list-wrap">
                {/*{pageResult &&*/}
                {/*    <Alert severity='info' icon={false}>*/}
                {/*        Found {pageResult.totalElements} record(s).*/}
                {/*        {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}*/}
                {/*    </Alert>}*/}
                {pageResult && pageResult.content && pageResult.content.length > 0 ?
                    <ContributionsAsWidgetList contributions={pageResult.content} setSnackbarOpen={(s) => setSnackbarMsg(s)} minimum={true}/>
                    : <Alert severity='info' icon={false}>No Contributions Found</Alert>
                }
            </div>
            }
        </StyledContainer>
    )
}
